/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_TextInputs */



/**
* | output |
* | --- |
* | "Please enter a folder name:" |
*
* @param {Explorer_Display_New_Folder_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_text = /** @type {((inputs?: Explorer_Display_New_Folder_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez entrer un nom de dossier :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie einen Ordnernamen ein:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome per la cartella:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, введите название папки:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, introduzca un nombre de carpeta:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入文件夹名称：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダ名を入力してください:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया फ़ोल्डर का नाम दर्ज करें:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira o nome da pasta:")
	return /** @type {LocalizedString} */ ("Please enter a folder name:")
});